import { render, staticRenderFns } from "./StatisticsContent.vue?vue&type=template&id=54942867"
import script from "./StatisticsContent.vue?vue&type=script&lang=ts"
export * from "./StatisticsContent.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsContent.vue?vue&type=style&index=0&id=54942867&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports